// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3Mmq0","rootSuccess":"CompleteLink_rootSuccess__1BSDd","rootFailure":"CompleteLink_rootFailure__3gVAM","isDisabled":"CompleteLink_isDisabled__iutRz"};